class TarotViewport extends HTMLElement {
	constructor() {
		super();
	}
}

class TarotTrack extends HTMLElement {
	constructor() {
		super();
	}
}

class TarotSlide extends HTMLElement {
	// This is the index the slide will render at
	// The SlideManager uses this to loop slides on the track
	// The renderIndex might be different from the slide index
	// #renderIndex;

	constructor() {
		super();

		// the original slide index position loaded from the DOM (logical index)
		this._index = 0;
		// the render index of the slide on the track
		// used by the slide manager to loop the slides around the viewport
		this._renderIndex = 0;
		// whether this slide is currently selected
		this._selected = false;
		// the original slide index position loaded from the DOM
		this._trackPosition = 0;
		// renderPosition - the final render position used in the DOM
		// usually used after trimming the slides on the left and right
		this._renderPosition = 0;
		// the center point of the slide based on the renderIndex
		// used in transform regions to calculate the percent
		// between two points on the track to apply transforms
		this._centerPoint = 0;
	}

	connectedCallback() {
		this.setAttribute('role', 'group');
		this.setAttribute('aria-roledescription', 'slide');
	}

	hide() {
		this.style.visibility = 'hidden';
		this.style.pointerEvents = 'none';
	}

	show() {
		this.style.visibility = '';
		this.style.pointerEvents = '';
	}
}

class TarotContent extends HTMLElement {
	constructor() {
		super();
	}
}

class TarotSlideIcon extends HTMLElement {
	constructor() {
		super();
	}
}

if (!customElements.get('tarot-viewport')) {
	customElements.define('tarot-viewport', TarotViewport);
}
if (!customElements.get('tarot-track')) {
	customElements.define('tarot-track', TarotTrack);
}
if (!customElements.get('tarot-slide')) {
	customElements.define('tarot-slide', TarotSlide);
}
if (!customElements.get('tarot-content')) {
	customElements.define('tarot-content', TarotContent);
}
if (!customElements.get('tarot-slide-icon')) {
	customElements.define('tarot-slide-icon', TarotSlideIcon);
}
